// extracted by mini-css-extract-plugin
module.exports = {"star":"style__star__DGSbD"};